<template>
  <div class="fixed h-screen w-screen top-16 left-0 bg-black bg-opacity-30 flex justify-center" />
</template>

<script setup lang='ts'>

</script>

<style></style>
